export default __webpack_public_path__ + "static/media/offer1.686a3cae.jpg";